import { LocationQuery } from 'vue-router';
import { http } from '../../helpers/http.helper';
import { ApiResource } from './../../models/api-resource.interface';
import { Language } from './language.interface';

export class LanguageService {
   async getLanguages(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<Language>>>(`/languages`, { params: { ...query } });
      return response.data;
   }
}
